import * as likeIdeaApi from '../api/like-idea'
import { handleApiError } from './api-errors'
import { showSuccess } from './alerts'

export const LIKE_IDEA = 'LIKE_IDEA'
export const UNLIKE_IDEA = 'UNLIKE_IDEA'

export const likeIdea = (idea_id) => (dispatch) => {
    likeIdeaApi
        .putObj(idea_id)
        .then((res) => {
            dispatch({
                type: LIKE_IDEA,
                payload: res,
            })
            dispatch(showSuccess('Idea liked!'))
        })
        .catch((err) => dispatch(handleApiError(err)))
}

export const unlikeIdea = (idea_id) => (dispatch) => {
    likeIdeaApi
        .deleteObj(idea_id)
        .then((res) => {
            dispatch({
                type: UNLIKE_IDEA,
                payload: res,
            })
            dispatch(showSuccess('Removed like!'))
        })
        .catch((err) => dispatch(handleApiError(err)))
}
